import { apiFetchJson } from "./apiClient";
import {
  Character,
  CharacterListItem,
  CharacterRequest,
  CharacterListRequest,
  CharacterListResponse,
  CharacterDiceTemplate,
  CharacterDiceTemplateRequest,
} from "../types/types";

export class CharacterService {
  // Get all user characters (simple list)
  static async getCharacters(): Promise<CharacterListItem[]> {
    return apiFetchJson("/api/protected/characters");
  }

  // Get characters with pagination and filtering
  static async getCharacterList(request: CharacterListRequest): Promise<CharacterListResponse> {
    return apiFetchJson("/api/protected/characters", {
      method: "POST",
      body: JSON.stringify(request),
    });
  }

  // Create a new character
  static async createCharacter(character: CharacterRequest): Promise<Character> {
    return apiFetchJson("/api/protected/characters/character", {
      method: "POST",
      body: JSON.stringify(character),
    });
  }

  // Get character details
  static async getCharacter(id: number): Promise<Character> {
    return apiFetchJson(`/api/protected/characters/character/${id}`);
  }

  // Update character
  static async updateCharacter(id: number, character: CharacterRequest): Promise<Character> {
    return apiFetchJson(`/api/protected/characters/character/${id}`, {
      method: "PUT",
      body: JSON.stringify(character),
    });
  }

  // Delete character
  static async deleteCharacter(id: number): Promise<{ message: string }> {
    return apiFetchJson(`/api/protected/characters/character/${id}`, { method: "DELETE" });
  }

  // Duplicate a character as a standalone (campaign-unassigned) copy
  static async duplicateCharacter(id: number): Promise<Character> {
    return apiFetchJson(`/api/protected/characters/character/${id}/duplicate`, { method: "POST" });
  }

  // Get character dice templates
  static async getCharacterDiceTemplates(characterId: number): Promise<CharacterDiceTemplate[]> {
    return apiFetchJson(`/api/protected/characters/character/${characterId}/dice-templates`);
  }

  // Create dice template
  static async createDiceTemplate(
    characterId: number,
    template: CharacterDiceTemplateRequest
  ): Promise<CharacterDiceTemplate> {
    return apiFetchJson(`/api/protected/characters/character/${characterId}/dice-templates`, {
      method: "POST",
      body: JSON.stringify(template),
    });
  }

  // Update dice template
  static async updateDiceTemplate(
    characterId: number,
    templateId: number,
    template: CharacterDiceTemplateRequest
  ): Promise<CharacterDiceTemplate> {
    return apiFetchJson(
      `/api/protected/characters/character/${characterId}/dice-templates/${templateId}`,
      { method: "PUT", body: JSON.stringify(template) }
    );
  }

  // Delete dice template
  static async deleteDiceTemplate(
    characterId: number,
    templateId: number
  ): Promise<{ message: string }> {
    return apiFetchJson(
      `/api/protected/characters/character/${characterId}/dice-templates/${templateId}`,
      { method: "DELETE" }
    );
  }
}

export const characterService = new CharacterService();
